import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PatientIdsDialogComponent } from '../patient-ids-dialog/patient-ids-dialog.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-client-list-item',
  templateUrl: './client-list-item.component.html',
  styleUrls: ['./client-list-item.component.scss'],
  standalone: false
})
export class ClientListItemComponent implements OnInit {
  @Input() client: {
    firstname: string;
    lastname: string;
    caseName: string;
    gender: string;
    dob: string;
    createdAt?: Date;
    patientIDs?: Array<{ value: string; facility: string }>;
  };
  @Input() hasNotifications: boolean;
  @Input() permissions: any;
  @Output() editClient = new EventEmitter<any>();

  currentFacility: string = '';
  currentFacilityPatientId: string = '';
  hasMorePatientIds: boolean = false;

  constructor(private dialog: MatDialog, private authService: AuthService) {}

  ngOnInit(): void {
    // Get current user's facility
    const userData = this.authService.userData.getValue();
    this.currentFacility = userData?.['facility'] || '';
    
    // Find current facility's patient ID and check if there are more
    this.processPatientIds();
  }

  private processPatientIds(): void {
    if (!this.client.patientIDs || this.client.patientIDs.length === 0) {
      this.currentFacilityPatientId = '';
      this.hasMorePatientIds = false;
      return;
    }

    // Find patient ID for current facility
    const currentFacilityId = this.client.patientIDs.find(id => 
      id.facility.toLowerCase() === this.currentFacility.toLowerCase()
    );

    if (currentFacilityId) {
      this.currentFacilityPatientId = currentFacilityId.value;
      this.hasMorePatientIds = this.client.patientIDs.length > 1;
    } else {
      // If no ID for current facility, show the first one and indicate there are more
      if (this.client.patientIDs.length > 0) {
        this.currentFacilityPatientId = this.client.patientIDs[0].value;
        this.hasMorePatientIds = this.client.patientIDs.length > 1;
      } else {
        this.currentFacilityPatientId = '';
        this.hasMorePatientIds = false;
      }
    }
  }

  public handleEditClient(event, item) {
    event.preventDefault();
    event.stopPropagation();
    this.editClient.emit(item);
  }

  public viewPatientIds(event) {
    event.preventDefault();
    event.stopPropagation();
    
    const patientName = `${this.client.firstname} ${this.client.lastname}`.trim();
    
    this.dialog.open(PatientIdsDialogComponent, {
      width: '500px',
      maxWidth: '90vw',
      height: 'auto',
      maxHeight: '80vh',
      data: {
        patientIDs: this.client.patientIDs,
        patientName: patientName
      }
    });
  }

  public isValidDate(dateString: string): boolean {
    if (!dateString || dateString.trim() === '') {
      return false;
    }
    
    const date = new Date(dateString);
    return !isNaN(date.getTime());
  }
}
